import { Badge, Tooltip, TooltipContent, TooltipTrigger } from '@procureai/uix';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { SvbrgIntakeSupplierSource } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';
import { NULLISH_CELL_VALUE } from '~/components/DataGridCustom';

export type IntakeSupplierSourceChipProps = {
  value: SvbrgIntakeSupplierSource | null | undefined;
};

export const IntakeSupplierSourceChip = (props: IntakeSupplierSourceChipProps): ReactNode => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'SupplierSource' });

  if (!props.value) {
    return <>{NULLISH_CELL_VALUE}</>;
  }

  return (
    <Tooltip>
      <TooltipTrigger render={<Badge variant="secondary">{t(`label.${props.value}`)}</Badge>} />
      <TooltipContent>{t(`tooltip.${props.value}`)}</TooltipContent>
    </Tooltip>
  );
};
